import React from "react";
import { useTranslation } from "react-i18next";

/*
 * Escala 0-10 em tamanho de totem. Componente proprio, e nao o NpsScore da
 * pagina de complemento: aquele esta vivo em /nps/:customer/:requestId, que e
 * justamente o destino do QR Code, e depende de hover e de ?npsRating= — duas
 * coisas erradas num balcao.
 */

export function ratingBand(rating) {
  if (rating >= 9) return "promoter";
  if (rating >= 7) return "passive";

  return "detractor";
}

export function KioskScale({ onPick }) {
  const { t } = useTranslation();

  return (
    <div className="kiosk-scale">
      <div className="kiosk-scale-row">
        {[...Array(11)].map((x, rating) => (
          <button
            key={rating}
            type="button"
            className={`kiosk-chip kiosk-chip-${ratingBand(rating)}`}
            onClick={() => onPick(rating)}
          >
            {rating}
          </button>
        ))}
      </div>

      <p className="kiosk-legend">
        <span className="kiosk-legend-detractor">0</span>
        <span className="kiosk-legend-text">{t("kiosk.legend_low")}</span>
        <span className="kiosk-legend-separator">·</span>
        <span className="kiosk-legend-promoter">10</span>
        <span className="kiosk-legend-text">{t("kiosk.legend_high")}</span>
      </p>
    </div>
  );
}
